import { HttpClient } from './serviceBase';
import { utils } from '../utils/utils'


class BillingService {
    GetSellerSales = async ( filters ) => {
        const queryString = utils.GetQueryStringsFromObject( filters );
        return await HttpClient.Get(`/api/billing/sellerSales?${queryString}`);
    }

    GetInvoiceSummary = async (from, to, billingCode, branchCode) => {
        const queryString = utils.GetQueryStringsFromObject({ from, to, billingCode, branchCode });
        return await HttpClient.Get(`/api/billing/invoiceSummary?${queryString}`);
    }

    SearchInvoices = async (search) =>
        await HttpClient.Post(`/api/billing/search`, search);

    GetInvoice = async (invoiceId) =>
        await HttpClient.Get(`/api/billing/${invoiceId}`);

    GetTotalSummary = async ( branchCode ) =>
        await HttpClient.Get(`/api/billing/${branchCode}/totalsSales`);
    
    Reinstate = async ( voucherId, voucherType ) =>
        await HttpClient.Post(`/api/billing/reinstate/${voucherId}/${voucherType}`);

    SearchVouchers = async (search) =>
        await HttpClient.Post(`/api/billing/search/vouchers`, search);

    GetVoucher = async (voucherId) =>
        await HttpClient.Get(`/api/billing/vouchers/${voucherId}`);
    
    PrintCloseZ = async (billingCode, businessId) =>
        await HttpClient.Get(`/api/billing/${billingCode}/print-closez?businessId=${businessId}`);    
}

export default new BillingService();